import React, { useState, useEffect } from "react";
import axios from "axios";
import MSAForm from "./MSAForm";
import { useParams, useHistory } from "react-router-dom";
import { useQuery } from "../../components/Control/useQuery";

const EditMSA = () => {
  const { id } = useParams();
  const history = useHistory();
  const { partId } = useParams();
  const query = useQuery();
  const partNumber = query.get("partNumber");
  const partName = query.get("partName");

  const [MSAData, setMSAData] = useState({
    rev_no: null,
    part_no: null,
    part_name: "",
    characteristic: "",
    spec: "",
    gage_no: "",
    gage_name: "",
    gage_type: "",
    data: [...Array(3)].map((item) => ({
      name: "",
      values: Array.from(Array(3), () => Array.from(Array(10), () => "")),
    })),
    least_count: "",
    date_performance: "",
    isSubmitted: null,
  });

  useEffect(() => {
    axios.get(`/api/oneMsa/data/${id}`).then((response) => {
      setMSAData(response.data);
    });
  }, []);

  const submit = () => {
    axios.post(`/api/update/msa/${id}`, MSAData).then((res) => {
      history.push(
        `/view/msaTable/${MSAData.part_id._id}?partNumber=${partNumber}&partName=${partName}`
      );
    });
  };

  return (
    <>
      <MSAForm {...{ MSAData, submit, setMSAData }} />
    </>
  );
};

export default EditMSA;
